module.exports = __webpack_public_path__ + "static/User-Perspectives-design-thinking-6ae5d62c8e22bc79fc5dd1d470f13896.png";